//# sourceMappingURL=connected_sockets.mjs.map
/// <reference types="./connected_sockets.d.mts" />
import * as $user_id from "../../../data_types/data/auth/user_id.mjs";
import * as $wss_connected from "../../../data_types/data/ephemeral/wss_connected.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $checkbox from "../../../ds/ds/components/checkbox.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $loader from "../../../ds/ds/components/loader.mjs";
import * as $table from "../../../ds/ds/components/table.mjs";
import * as $typography from "../../../ds/ds/components/typography.mjs";
import * as $icons from "../../../ds/ds/icons.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $set from "../../../gleam_stdlib/gleam/set.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $user from "../../admin/effects/user.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, toList, prepend as listPrepend, makeError } from "../../gleam.mjs";

const FILEPATH = "src/view/administration/connected_sockets.gleam";

function text(text) {
  return $typography.text($typography.sm, $typography.regular, text);
}

function user_row(entry) {
  let socket = entry[0];
  let socket_count = entry[1];
  let clients = entry[2];
  return $table.row(
    toList([
      $table.cell(text("")),
      $table.cell(text(socket.user_name)),
      $table.cell(text($user_id.to_string(socket.user_id))),
      $table.cell(text($int.to_string(socket_count))),
      $table.cell(text($string.join(clients, ", "))),
    ]),
  );
}

function users_of_org(org_sockets) {
  let grouped = $list.group(org_sockets, (s) => { return s.user_id; });
  let _pipe = $dict.keys(grouped);
  return $list.map(
    _pipe,
    (user_id) => {
      let $ = $dict.get(grouped, user_id);
      let user_sockets;
      if ($ instanceof Ok) {
        user_sockets = $[0];
      } else {
        throw makeError(
          "let_assert",
          FILEPATH,
          "view/administration/connected_sockets",
          153,
          "users_of_org",
          "Pattern match failed, no pattern matched the value.",
          {
            value: $,
            start: 4103,
            end: 4159,
            pattern_start: 4114,
            pattern_end: 4130
          }
        )
      }
      let $1 = $list.first(user_sockets);
      let first;
      if ($1 instanceof Ok) {
        first = $1[0];
      } else {
        throw makeError(
          "let_assert",
          FILEPATH,
          "view/administration/connected_sockets",
          154,
          "users_of_org",
          "Pattern match failed, no pattern matched the value.",
          {
            value: $1,
            start: 4164,
            end: 4211,
            pattern_start: 4175,
            pattern_end: 4184
          }
        )
      }
      let socket_count = $list.length(user_sockets);
      let _block;
      let _pipe$1 = user_sockets;
      let _pipe$2 = $list.map(_pipe$1, (s) => { return s.client_type; });
      let _pipe$3 = $set.from_list(_pipe$2);
      _block = $set.to_list(_pipe$3);
      let clients = _block;
      return [first, socket_count, clients];
    },
  );
}

function clickable_icon(up, on_click) {
  return $h.div(
    $css.class$(toList([$css.display("flex"), $css.justify_content("center")])),
    toList([$e.on_click((_) => { return on_click(); })]),
    toList([
      $icons.small(
        (() => {
          if (up) {
            return $icons.arrow_up_line();
          } else {
            return $icons.arrow_down_line();
          }
        })(),
      ),
    ]),
  );
}

function org_row(org_sockets, open, is_ignored, toggle_open, toggle_ignored) {
  let $ = $list.first(org_sockets);
  let first;
  if ($ instanceof Ok) {
    first = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "view/administration/connected_sockets",
      172,
      "org_row",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 4549,
        end: 4595,
        pattern_start: 4560,
        pattern_end: 4569
      }
    )
  }
  let _block;
  let _pipe = org_sockets;
  let _pipe$1 = $list.map(_pipe, (s) => { return s.user_id; });
  let _pipe$2 = $set.from_list(_pipe$1);
  let _pipe$3 = $set.to_list(_pipe$2);
  _block = $list.length(_pipe$3);
  let user_count = _block;
  return $table.row(
    toList([
      $table.cell(
        $checkbox.checkbox(
          $checkbox.checked(!is_ignored),
          false,
          toggle_ignored(first.org_id),
        ),
      ),
      $table.cell(
        text(
          (() => {
            let _pipe$4 = first.organization_name;
            return $string.capitalise(_pipe$4);
          })(),
        ),
      ),
      $table.cell(text($int.to_string(user_count) + " users")),
      $table.cell(text("")),
      $table.cell(clickable_icon(open, toggle_open(first.org_id))),
    ]),
  );
}

function sockets_display() {
  return $redraw.component_(
    "SocketsConnectedTable",
    (sockets) => {
      let grouped_by_org = $list.group(sockets, (s) => { return s.org_id; });
      let _block;
      let _pipe = grouped_by_org;
      _block = $dict.keys(_pipe);
      let orgs = _block;
      let $ = $redraw.use_state(
        (() => {
          let _pipe$1 = orgs;
          let _pipe$2 = $list.map(_pipe$1, (o) => { return [o, false]; });
          return $dict.from_list(_pipe$2);
        })(),
      );
      let opened = $[0];
      let set_opened = $[1];
      let $1 = $redraw.use_state($set.new$());
      let ignored_orgs = $1[0];
      let set_ignored_orgs = $1[1];
      let toggle_open = (org_id) => {
        return () => {
          let _pipe$1 = $dict.upsert(
            opened,
            org_id,
            (o) => {
              if (o instanceof Some) {
                let o$1 = o[0];
                return $bool.negate(o$1);
              } else {
                return true;
              }
            },
          );
          return set_opened(_pipe$1);
        };
      };
      let toggle_ignored = (org_id) => {
        return (checked) => {
          let _block$1;
          if (checked) {
            _block$1 = $set.delete$(ignored_orgs, org_id);
          } else {
            _block$1 = $set.insert(ignored_orgs, org_id);
          }
          let _pipe$1 = _block$1;
          return set_ignored_orgs(_pipe$1);
        };
      };
      let _block$1;
      let _pipe$1 = sockets;
      let _pipe$2 = $list.filter(
        _pipe$1,
        (s) => { return !$set.contains(ignored_orgs, s.org_id); },
      );
      let _pipe$3 = $list.map(_pipe$2, (s) => { return s.user_id; });
      let _pipe$4 = $set.from_list(_pipe$3);
      let _pipe$5 = $set.to_list(_pipe$4);
      _block$1 = $list.length(_pipe$5);
      let unique_user_count = _block$1;
      let _block$2;
      if (unique_user_count === 0) {
        _block$2 = "No users connected";
      } else if (unique_user_count === 1) {
        _block$2 = "1 user connected";
      } else {
        let n = unique_user_count;
        _block$2 = $int.to_string(n) + " users connected";
      }
      let count_text = _block$2;
      return $l.column(
        toList([$l.gap(8)]),
        toList([]),
        toList([
          text(count_text),
          $table.table(
            toList([]),
            toList([
              $table.headers(
                toList([
                  (() => {
                    let _pipe$6 = $table.header("");
                    return $table.fit(_pipe$6);
                  })(),
                  (() => {
                    let _pipe$6 = $table.header("organization");
                    return $table.clamp(_pipe$6, "250px", 300);
                  })(),
                  (() => {
                    let _pipe$6 = $table.header("users");
                    return $table.fit(_pipe$6);
                  })(),
                  (() => {
                    let _pipe$6 = $table.header("sockets");
                    return $table.fit(_pipe$6);
                  })(),
                  (() => {
                    let _pipe$6 = $table.header("");
                    return $table.fit(_pipe$6);
                  })(),
                ]),
              ),
              $table.body(
                $list.flat_map(
                  orgs,
                  (org) => {
                    let _block$3;
                    let _pipe$6 = grouped_by_org;
                    _block$3 = $dict.get(_pipe$6, org);
                    let $2 = _block$3;
                    let org_sockets;
                    if ($2 instanceof Ok) {
                      org_sockets = $2[0];
                    } else {
                      throw makeError(
                        "let_assert",
                        FILEPATH,
                        "view/administration/connected_sockets",
                        128,
                        "sockets_display",
                        "Pattern match failed, no pattern matched the value.",
                        {
                          value: $2,
                          start: 3379,
                          end: 3439,
                          pattern_start: 3390,
                          pattern_end: 3405
                        }
                      )
                    }
                    let _block$4;
                    let $3 = (() => {
                      let _pipe$7 = opened;
                      return $dict.get(_pipe$7, org);
                    })();
                    if ($3 instanceof Ok) {
                      let $4 = $3[0];
                      if ($4) {
                        _block$4 = true;
                      } else {
                        _block$4 = false;
                      }
                    } else {
                      _block$4 = false;
                    }
                    let is_open = _block$4;
                    let is_ignored = $set.contains(ignored_orgs, org);
                    return listPrepend(
                      org_row(
                        org_sockets,
                        is_open,
                        is_ignored,
                        toggle_open,
                        toggle_ignored,
                      ),
                      (() => {
                        if (is_open) {
                          let _pipe$7 = org_sockets;
                          let _pipe$8 = users_of_org(_pipe$7);
                          return $list.map(_pipe$8, user_row);
                        } else {
                          return toList([]);
                        }
                      })(),
                    );
                  },
                ),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

export function list_sockets_connected() {
  return $redraw.compose(
    sockets_display(),
    (sockets_display) => {
      return $redraw.component_(
        "SocketsConnected",
        (_) => {
          let store = $store.use_state();
          let dispatch = $store.use_effect_dispatch();
          let _block;
          let $ = store.connected_sockets;
          if ($ instanceof $remote.NotLoaded) {
            _block = text("Click to load connections");
          } else if ($ instanceof $remote.Loading) {
            _block = $loader.loader(toList(["Loading current connections"]));
          } else if ($ instanceof $remote.Errored) {
            let e = $[0];
            _block = text("Someting went wrong : " + e);
          } else {
            let sockets = $[0];
            _block = sockets_display(sockets);
          }
          let display = _block;
          return $l.column(
            toList([$l.gap(12)]),
            toList([]),
            toList([
              $l.row(
                toList([$l.justify("center"), $l.align("center"), $l.gap(48)]),
                toList([
                  $e.on_click(
                    (_) => {
                      dispatch($user.fetch_sockets());
                      return undefined;
                    },
                  ),
                ]),
                toList([$button.primary(toList([]), toList([text("Refresh")]))]),
              ),
              display,
            ]),
          );
        },
      );
    },
  );
}
